import { render, staticRenderFns } from "./SelecionarImagemCapaDialog.vue?vue&type=template&id=cbf571c4&scoped=true&"
import script from "./SelecionarImagemCapaDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarImagemCapaDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarImagemCapaDialog.vue?vue&type=style&index=0&id=cbf571c4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf571c4",
  null
  
)

export default component.exports